import clsx from 'clsx'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import styles from './SaveErrorBanner.module.scss'

const SUPPORT_URL = 'https://support.augmentt.com'

/**
 * Error shown at the top of the edit panel when the user's settings fail to load or save.
 */
function SaveErrorBanner() {
  return (
    <div className={clsx('px-4 py-3 d-flex align-items-center', styles.banner)} role="alert">
      <i className={clsx('fas fa-circle-xmark me-3', styles.icon)} aria-hidden="true" />
      <p className="mb-0">
        <FormattedMessage id="GENERAL.ERROR" />{' '}
        <a href={SUPPORT_URL} target="_blank" rel="noopener noreferrer">
          <FormattedMessage id="GENERAL.CONTACT_SUPPORT" />
        </a>
      </p>
    </div>
  )
}

export default React.memo(SaveErrorBanner)
